export default {
  state: {
    update: {
      show: false
    }
  },
  mutations: {
    showUpdate (state) { state.update.show = true },
    hideUpdate (state) { state.update.show = false }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/update.js